export const getVippsForm = (state) => state.vippsForm;
export const getVippsEnabled = (state) => state.configFeatureToggles.vippsEnabled;
export const getVippsGiveMaxAmount = (state) => state.paymentConfig.vippsGiveMaxAmount;
